exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-overflow{overflow:inherit!important}.review-image img{width:60px!important;height:60px!important}.user_name{width:68%;font-weight:600;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;color:rgba(54,54,54,.6)}.review-image{width:100px}.review_image{margin-bottom:10px;border-radius:50%}.review-content{padding:0!important}.review-inner{margin:0 0 0 140px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1a77ac1a","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Feedback.vue
// module id = BLEH
// module chunks = 0